import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

export function PreventVolunteerAddOthersInReports() {
  const [queryPreventVolunteerAddOthersInReports] = useCampfireLazyQuery<GetConfigItem, { key: string }>(
    GET_CONFIG_ITEM
  );
  const [preventVolunteerAddOthersInReports, setPreventVolunteerAddOthersInReports] = React.useState<
    boolean | undefined
  >();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryPreventVolunteerAddOthersInReports({
      variables: { key: 'prevent-volunteer-add-others-in-reports' },
    }).then((response) =>
      setPreventVolunteerAddOthersInReports(
        response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue
      )
    );
  }, []);

  const savePreventVolunteerAddOthersInReports = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    savePreventVolunteerAddOthersInReports
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'prevent-volunteer-add-others-in-reports',
          value: !preventVolunteerAddOthersInReports,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setPreventVolunteerAddOthersInReports(!preventVolunteerAddOthersInReports);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(preventVolunteerAddOthersInReports)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'prevent volunteer add others in reports' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Prevent Volunteers from Adding Others in Reports
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Hide "Add Volunteer" button from general volunteers in session reports. Activity Leaders, Program Managers, and Admins will still be able to add other volunteers to reports as normal.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
